import React from "react";

export const PageHeader = ({ title, subtitle, right, testId }) => (
    <div className="flex items-end justify-between gap-6 mb-8" data-testid={testId}>
        <div>
            <h1 className="font-display text-4xl sm:text-5xl text-[color:var(--slate-deep)] leading-tight tracking-tight">
                {title}
            </h1>
            {subtitle && (
                <p className="font-body text-base text-[color:var(--slate-mid)] mt-1.5">
                    {subtitle}
                </p>
            )}
        </div>
        {right && <div className="flex items-center gap-3">{right}</div>}
    </div>
);
